module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_7042.a5af879d.png";